import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'vsf-preview-mode-banner',
    templateUrl: './preview-mode-banner.component.html',
})
export class PreviewModeBannerComponent {
    adminUrl: string = (environment as any).apiHost + '/admin/store-settings/general' || 'https://app.dealomega.com/admin/store-settings/general';
}
